var _rect, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeWinLose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_linear_1572_80527)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.472 38.8711H27.4945V40.8936C27.4945 41.1728 27.7209 41.3992 28.0002 41.3992C28.2794 41.3992 28.5058 41.1728 28.5058 40.8936V38.8711H30.5283C30.6624 38.8711 30.791 38.8178 30.8859 38.723C30.9807 38.6282 31.034 38.4995 31.034 38.3654V24.2078C31.034 24.0737 30.9807 23.9451 30.8859 23.8503C30.791 23.7554 30.6624 23.7022 30.5283 23.7022H28.5058V21.6796C28.5058 21.4004 28.2794 21.174 28.0002 21.174C27.7209 21.174 27.4945 21.4004 27.4945 21.6796V23.7022H25.472C25.3379 23.7022 25.2093 23.7554 25.1145 23.8503C25.0197 23.9451 24.9664 24.0737 24.9664 24.2078V38.3654C24.9664 38.4995 25.0197 38.6282 25.1145 38.723C25.2093 38.8178 25.3379 38.8711 25.472 38.8711Z",
    fill: "#1D1B18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1404 35.3316H20.1629V37.3542C20.1629 37.6334 20.3893 37.8598 20.6685 37.8598C20.9478 37.8598 21.1742 37.6334 21.1742 37.3542V35.3316H23.1967C23.3308 35.3316 23.4594 35.2784 23.5542 35.1835C23.6491 35.0887 23.7023 34.9601 23.7023 34.826V20.6684C23.7023 20.5343 23.6491 20.4057 23.5542 20.3108C23.4594 20.216 23.3308 20.1627 23.1967 20.1627H21.1742V18.1402C21.1742 17.861 20.9478 17.6346 20.6685 17.6346C20.3893 17.6346 20.1629 17.861 20.1629 18.1402V20.1627H18.1404C18.0063 20.1627 17.8777 20.216 17.7829 20.3108C17.688 20.4057 17.6348 20.5343 17.6348 20.6684V34.826C17.6348 34.9601 17.688 35.0887 17.7829 35.1835C17.8777 35.2784 18.0063 35.3316 18.1404 35.3316Z",
    fill: "#1D1B18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8037 32.2979H34.8262V34.3204C34.8262 34.5997 35.0526 34.826 35.3318 34.826C35.6111 34.826 35.8375 34.5997 35.8375 34.3204V32.2979H37.86C37.9941 32.2979 38.1227 32.2446 38.2175 32.1498C38.3123 32.055 38.3656 31.9264 38.3656 31.7923V17.6346C38.3656 17.5005 38.3123 17.3719 38.2175 17.2771C38.1227 17.1823 37.9941 17.129 37.86 17.129H35.8375V15.1065C35.8375 14.8272 35.6111 14.6008 35.3318 14.6008C35.0526 14.6008 34.8262 14.8272 34.8262 15.1065V17.129H32.8037C32.6696 17.129 32.541 17.1823 32.4461 17.2771C32.3513 17.3719 32.2981 17.5005 32.2981 17.6346V31.7923C32.2981 31.9264 32.3513 32.055 32.4461 32.1498C32.541 32.2446 32.6696 32.2979 32.8037 32.2979Z",
    fill: "#1D1B18"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1572_80527",
    x1: 0,
    y1: 28.002,
    x2: 56,
    y2: 28.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWinLose);
export default __webpack_public_path__ + "static/media/Home_Win_Lose.36545d585a9ff540d369210c75cde123.svg";
export { ForwardRef as ReactComponent };